import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { Location } from '../types';
import { showNotification } from '@/utils/notificationUtils';
export type SaveLocationDTO = {
  data?: Location;
};

export const deleteLocation = ({ data }: SaveLocationDTO) => {
  return axios.delete(`/business/locations/prefill/${data?.googlePlaceId}`);
};

type UseDeleteLocationOptions = {
  config?: MutationConfig<typeof deleteLocation>;
};

export const useDeleteLocation = ({ config }: UseDeleteLocationOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Location Deleted',
      });
    },
    ...config,
    mutationFn: deleteLocation,
  });
};
